import { render, staticRenderFns } from "./abs-box.vue?vue&type=template&id=4da43305&scoped=true&"
import script from "./abs-box.vue?vue&type=script&lang=ts&"
export * from "./abs-box.vue?vue&type=script&lang=ts&"
import style0 from "./abs-box.vue?vue&type=style&index=0&id=4da43305&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da43305",
  null
  
)

export default component.exports